import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {ProjectListItem} from "./ProjectListItem";
import {getProjects, clearProjects, removeProjectFavorite, addProjectFavorite, toggleHideProject } from "../../actions/projects";
import {alertPermissionsRequired} from "../../actions/messages";
import {getClassNamesForThButton, useSortableData, alphabetizeByAttributeReverse} from "../common/Helpers";


export function ProjectList(props) {

const projects = useSelector(state => state.projects.projects);
const noProjectsExist = useSelector(state => state.projects.noProjectsExist);
const showHiddenProjects = useSelector(state => state.projects.showHiddenProjects);
const project_favorites = useSelector(state => state.projects.project_favorites);

const orderedProjects = alphabetizeByAttributeReverse(projects, "project_date_created");


const orderedDates = orderedProjects.map(project => project.date_created)

const [render, setRender] = useState(noProjectsExist || projects.length > 0);

const { items, requestSort, sortConfig } = useSortableData(orderedProjects);       

// Start rendering the component only once the list data is returned
useEffect(() => {
    if (!render) {
        (noProjectsExist || projects.length > 0) && setRender(true);
    }
}, [noProjectsExist, projects]);


const handleSelectProjListItem = (id) => {
    props.history.push(`/mng/project/view/${id}`);
}

const handleToggleFavourite = (id) => {
    const projectIsFav = project_favorites.filter(projectFav => projectFav.project_id === id).length > 0;
    projectIsFav
    ? props.removeProjectFavorite(id)
    : props.addProjectFavorite(id);
}

const handleToggleVisibility = (project) => {
    props.toggleHideProject(project, showHiddenProjects);
}


const noResults = 
    <div className="page-card narrow light-black g5-text" >
        You have no projects yet.
    </div>

const projectTable = 
    <table className="card-table">
        <thead>
            <tr>
                <th className="content2 heavy-grey flexi first" colSpan="2" >
                    <button type="button" onClick={() => requestSort("project_name")} className={getClassNamesForThButton("project_name", sortConfig)}>
                        Project
                    </button>
                </th>
                <th className="content2 heavy-grey flexi" style={{width: "26%"}} >
                    <button type="button" onClick={() => requestSort("street")} className={getClassNamesForThButton("street", sortConfig)}>
                        Address
                    </button>
                </th>
                <th className="content2 heavy-grey flexi" style={{width: "22%"}} >
                    <button type="button" onClick={() => requestSort("project_date_created")} className={getClassNamesForThButton("project_date_created", sortConfig)}>
                        Created
                    </button>
                </th>
                <th className="content2 heavy-grey rigid last-cell" colSpan="2">
                    <button type="button" onClick={() => requestSort("status")} className={getClassNamesForThButton("status", sortConfig)} >
                        Status
                    </button>
                </th>
                <th className="content2 heavy-grey rigid last-cell" aria-label="Hide Project" colSpan="1">
                </th>
            </tr>
        </thead>
        <tbody>
            {items.map((project) => {
                return(
                    <ProjectListItem project={project} key={project.project_id} handleSelectProjListItem={handleSelectProjListItem} handleToggleVisibility={handleToggleVisibility} handleToggleFavourite={handleToggleFavourite} />
                )
            })}
        </tbody>
    </table>

    return (
        <>{render &&
            <>
                <div className="table-wrapper">
                    {projects.length > 0 ? projectTable : noResults}
                </div> 
            </>
        }</>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {getProjects, clearProjects, toggleHideProject, alertPermissionsRequired, removeProjectFavorite, addProjectFavorite })(ProjectList);